// Putting the Uniwind CSS import here ensures that hot-reload works even for
// lazy/async bundles, see https://github.com/uni-stack/uniwind/issues/642
import "@/global.css";

// oxlint-disable-next-line no-restricted-imports
export { View } from "react-native";
